module.exports = __webpack_public_path__ + "img/c_en.6ed93753.png";